import { render } from "./Choke.vue?vue&type=template&id=61fbba67&scoped=true"
import script from "./Choke.vue?vue&type=script&lang=js"
export * from "./Choke.vue?vue&type=script&lang=js"

import "./Choke.vue?vue&type=style&index=0&id=61fbba67&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fbba67"]])

export default __exports__